RivalIQ.module('overrides.bootstrap', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    // This is to close tooltips in this app when another tooltip is opened or if the user clicks somewhere
    // other than the tooltip on the screen.
    // It's based on http://mattlockyer.com/2013/04/08/close-a-twitter-bootstrap-popover-when-clicking-outside/
    $('body').on('click', function (e) {
        $('[data-trigger="click"]').each(function () {
            const tooltipTrigger = $(this);
            if (!tooltipTrigger.is(e.target) && tooltipTrigger.has(e.target).length === 0 && $('.tooltip').has(e.target).length === 0) {
                tooltipTrigger.tooltip('hide');
            }
        });
    });

    const popover = $.fn.popover;

    // Override the default popover delay to be 200ms
    // per https://github.com/RivalIQ/rivaliq-server/issues/10494
    _.extend(popover.Constructor.DEFAULTS, {
        delay: 200
    });

    $.fn.popover = function () {
        const me = this;
        me.addClass('rivaliq-popover');
        return popover.apply(me, arguments);
    };

});
